module.exports = __webpack_public_path__ + "static/bison-13447a18cc6bdd43466680bbcbb5eae6.webm";